import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import List from 'components/List';
import MapControls from 'components/MapControls';
import Map from 'components/Map';
import LocationDetails from 'components/LocationDetails';
import './index.scss';

/*
 * Types definition
 */
const propTypes = {
    currentLocation: PropTypes.string,
};

const defaultProps = {
    currentLocation: null,
};

/*
 * Component
 */
function StoreLocator({ currentLocation }) {
    return (
        <main className={`store-locator ${currentLocation ? 'location-details-open' : ''}`}>
            <div className="map-wrapper">
                <Map />
                <MapControls />
            </div>
            <List />
            {currentLocation && <LocationDetails />}
        </main>
    );
}

StoreLocator.propTypes = propTypes;
StoreLocator.defaultProps = defaultProps;

const mapStateToProps = state => ({
    currentLocation: state.currentLocation,
});

export default connect(mapStateToProps)(StoreLocator);
